

export const InputFocusedContextKey = 'inputFocus';